<template>
  <div class="card py-10 px-10">
    <!-- top -->
    <div class="flex flex-col items-center justify-center">
      <check-mark-icon />
      <h3 class="text-root-2 text-lg font-semibold my-2">
        Transaction Submitted
      </h3>
    </div>
    <!-- details -->
    <ul class="text-sm font-normal mt-10">
      <li class="flex items-center justify-between mb-3">
        <span class="text-root-4">You will send exactly</span>
        <span class="font-semibold text-lg">{{
          parseMoneyAll(transferDetails.debitAmount, country.currency)
        }}</span>
      </li>
      <li class="flex items-center justify-between mb-3">
        <span class="text-root-4">Exchange Rate</span>
        1 {{ !this.isDivisionOperator ? activeCurrency : secondaryCurrency }} =
        {{ exchangeRateBase }}
        {{ !this.isDivisionOperator ? secondaryCurrency : activeCurrency }}
      </li>
      <li class="flex items-center justify-between mb-3">
        <span class="text-root-4">Our Fees</span>
        <span class="text-sm">
          {{ parseMoneyAll(transferDetails.fees, country.currency) || 0 }}
        </span>
      </li>
      <li class="flex items-center justify-between mb-4">
        <span class="text-root-4">Recipient would receive</span>
        <span class="font-semibold text-lg">
          {{
            parseMoneyAll(transferDetails.recipientAmount, country2.currency)
          }}
        </span>
      </li>
      <!-- horizontal line break -->
      <hr />
      <p class="text-root-2 font-semibold mt-4">Estimated time of arrival</p>
      <li class="flex items-center justify-between mb-3 mt-4">
        <span class="text-root-4">Sending</span>
        <span class=""> Now</span>
      </li>
      <li class="flex items-center justify-between mb-3">
        <span class="text-root-4">Should arrive</span>
        <span class="">in 2days</span>
      </li>
    </ul>
    <!-- done -->
    <o-button class="mt-8" @click="done">Done</o-button>
    <transaction-processing
      v-if="showTransferProcessingDialog"
      :showDialog="showTransferProcessingDialog"
      @closeDialog="closeTransferProcessingDialog"
      @showSuccess="showSuccess"
    />
    <beneficiary-saved-success-dialog
      v-if="showSuccessDialog"
      :showDialog="showSuccessDialog"
      @closeDialog="closeSuccessDialog"
    />
  </div>
</template>

<script>
import { ParseMoneyAll } from '@/utils/helpers'
import country from '@/mixins/getCountryDetails.js'
import localDeposit from '@/mixins/localDeposit.js'
export default {
  mixins: [country, localDeposit],
  data () {
    return {
      showTransferProcessingDialog: false,
      showSuccessDialog: false
    }
  },
  components: {
    CheckMarkIcon: () => import('@/assets/icons/CheckMarkIcon.vue'),
    TransactionProcessing: () => import('../TransactionProcessing.vue'),
    BeneficiarySavedSuccessDialog: () =>
      import('../BeneficiarySavedSuccessDialog.vue')
  },
  computed: {
    transferDetails () {
      return (
        this.$store.state.terminal.transferTerminalDetails.transferDetails || {}
      )
    },
    routeName () {
      return this.$route.name
    },
    usedBeneficiary () {
      return this.$store.state.terminal.usedBeneficiary
    }
  },
  methods: {
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    closeTransferProcessingDialog () {
      this.showTransferProcessingDialog = false
    },
    done () {
      if (this.routeName === 'terminal' && !this.usedBeneficiary) {
        this.showTransferProcessingDialog = true
      } else {
        this.$router.push('transactions')
        this.$store.dispatch('terminal/resetTerminalState')
      }
    },
    showSuccess () {
      this.showSuccessDialog = true
    },
    closeSuccessDialog () {
      this.$router.push({ name: 'transactions' })
    }
  },
  beforeDestroy () {
    this.$store.dispatch('terminal/hasBeenDebited', false)
  }
}
</script>

<style scoped>
.card {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.1),
    0px 4px 8px rgba(3, 2, 7, 0.1);
  border-radius: 15px;
}
</style>
